import { ComponentType, ReactNode } from "react";

export const withLDWrapper: (children: ReactNode) => ComponentType<{}> = (children) => {
    return () => children;
};